import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Required by @backstage/ui (used internally by core-app-api/core-components since
// 1.54): defines the --bui-* design tokens plus body font defaults and
// `:where(a){text-decoration:none}`. Without it links render underlined and
// fonts/sizing fall back to browser defaults.
import '@backstage/ui/css/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
